/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'


import { Card } from 'primereact/card'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { Checkbox } from 'primereact/checkbox'
import { InputText } from 'primereact/inputtext'

import back from '../assets/images/back.svg'

import { userActions } from '../_actions'

export default function MapKeysComponent({ mapkeysList, updateMapkeys, getAllMapKeys }) {
  const [mapkeysData, setMapkeysData] = useState([])
  const [mapkeysSubData, setMapkeysSubData] = useState([])
  const history = useHistory()
  const [isSelectAll, setIsSelectAll] = useState(false)
  const [search, setSearch] = useState('')
  const [filter, setFilter] = useState('')
  useEffect(() => {
    processMapKey(mapkeysList)
  }, [mapkeysList])
  useEffect(() => {
    getAllMapKeys()
  }, [])

  const processMapKey = (mapkeysList) => {
    const mapkeysArray = []
    const mapkeysSubArray = []
    let all = true
    for (let i = 0; i < mapkeysList.length; i++) {
      const mapkeys = mapkeysList[i]
      if (!mapkeys.value) {
        all = false
      }
      if (!mapkeys?.parentId) {
        mapkeysArray.push({ 'name': mapkeys.name, 'configId': mapkeys.configId, 'action': '', 'value': mapkeys.value, 'parentId': mapkeys.parentId, 'createdOn': mapkeys.createdOn, 'updatedOn': mapkeys.createdOn, 'createdBy': mapkeys.createdBy, 'updatedBy': mapkeys.updatedBy })
      } else {
        mapkeysSubArray.push({ 'name': mapkeys.name, 'configId': mapkeys.configId, 'action': '', 'value': mapkeys.value, 'parentId': mapkeys.parentId, 'createdOn': mapkeys.createdOn, 'updatedOn': mapkeys.createdOn, 'createdBy': mapkeys.createdBy, 'updatedBy': mapkeys.updatedBy })
      }
    }
    if (all)
      setIsSelectAll(true)
    else
      setIsSelectAll(false)
    setMapkeysData(mapkeysArray)
    setMapkeysSubData(mapkeysSubArray)
  }

  const saveMapkeys = () => {
    mapkeysSubData.map(element => (
      mapkeysData.push(element)
    ))
    processMapKey(mapkeysData)
    updateMapkeys(mapkeysData)
  }
  const BackClick = () => {
    history.goBack()
  }
  const headerVal = <div className="p-clearfix" style={{ 'lineHeight': '1.87em' }}>ACTION <Checkbox checked={isSelectAll} onChange={e => selectAllEvent(e)} style={{ 'float': 'left' }} /></div>
  const checkBoxEnableDisable = (event, rowData, isParent) => {
    if (isParent) {
      setMapkeysData(processChecked(mapkeysData, event.checked, rowData.configId, true))
    }
    else {
      setMapkeysSubData(processChecked(mapkeysSubData, event.checked, rowData.configId, true))
    }
  }
  const processChecked = (array, checked, id, isIdCheck) => {
    const filtered = array.map(element => {
      if (isIdCheck) {
        if (element.configId === id) {
          element.value = checked
        }
      } else {
        element.value = checked
      }
      element.updatedBy = userActions.getCurrentUser()
      return element
    })
    return filtered
  }
  const onSearchChange = (e) => {
    const { value } = e.target
    setSearch(value)
  }
  const searchByName = () => {
    setFilter(search)
  }
  const onEnterKeySearch = (event) => {
    var code = (event.keyCode ? event.keyCode : event.which)
    if (code === 13) {
      searchByName()
    }
  }
  const selectAllEvent = (e) => {
    setIsSelectAll(e.checked)

    setMapkeysData(processChecked(mapkeysData, e.checked, null, false))
    setMapkeysSubData(processChecked(mapkeysSubData, e.checked, null, false))
  }
  const actionTemplate = (rowData) => {
    const subRow = mapkeysSubData.filter(f => f.parentId === rowData.configId)
    if (subRow?.length > 0) {
      return (<>
        <div className="checkbox-flex">
          {mapkeysSubData.map((element, index) => (
            // eslint-disable-next-line react/jsx-key
            <div className="checkbox-space" key={'mapkey_' + index}>
              <Checkbox checked={element.value} onChange={e => checkBoxEnableDisable(e, element, false)} />
              <label htmlFor="cb1" className="p-checkbox-label">{element.name}</label>
            </div>
          ))}
        </div>
      </>
      )
    }
    else {
      return <div className="flex" key="mapkey_all">
        <Checkbox checked={rowData.value} onChange={e => checkBoxEnableDisable(e, rowData, true)} />
      </div>
    }
  }

  return (
    <div className="p-col-10 dashboard mapKeysScrollFix">
      <div className="dashboard--wrapper">
        <Card className="cardBase addSector">
          <div className="titleCon m-b-20">
            <p className="title flex">
              <img src={back} alt={back} className="m-r-10 pointer" onClick={() => BackClick()} />MAP KEYS
            </p>
            <div className="flex">
              <div className="p-inputgroup customSearch">
                <InputText placeholder="Search" value={search} onChange={onSearchChange} onKeyUp={(e) => onEnterKeySearch(e)} />
                <Button icon="pi pi-search" className="p-button-warning" onClick={() => searchByName()} />
              </div>
            </div>
          </div>
          <DataTable className="manageTableHeight" value={mapkeysData} globalFilter={filter}>
            <Column key={'name'} name="name" field={'name'} header={'NAME'} style={{ textAlign: 'left', width: '15em' }} />
            <Column key={'action'} name="action" field={'action'} header={headerVal} body={actionTemplate} style={{ textAlign: 'center', width: '20em' }} />
          </DataTable>
        </Card>
        <div className="flex m-t-10 p-justify-end">
          <Button label="Save" className="p-button-raised p-button-rounded inputHolder--formBtn" onClick={() => saveMapkeys()} />
        </div>
      </div>
    </div>
  )
}
MapKeysComponent.propTypes = {
  mapkeysList: PropTypes.array,
  updateMapkeys: PropTypes.func,
  getAllMapKeys: PropTypes.func,
}
